<!--
  Implementation

  -in template:
    <section-header :title="$t('servicesystem.common_objects.job.job')"></section-header>
  
  -import:
    import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";

-->

<template >
  <v-container class="d-flex flex-column pa-0"
               :class="nopad ? '':'py-2'"
               fluid>
    <div class="d-flex"
         :class="leftpad">
      <v-icon v-if="icon"
              v-text="icon"
              :color="invalid ? 'error' : ''"
              :class="spaceBetweenIconAndText" />
      <component :is="fontsize ? fontsize : 'h3'"
                 :class="invalid ? 'error--text' : ''"
                 class="useThemeTextColor align-self-center">{{(title ? title : 'No title') + (noempty ? ' *':'')}}</component>
      <v-spacer />
      <slot name="button"></slot>
    </div>
    <v-divider v-if="noClutter" />
  </v-container>
</template>

<script>
export default {
  name: "SectionHeader",
  props: ["title", "icon", "fontsize", "invalid", "noempty", "nopad", "leftpad", "noClutter"],

  data: () => ({}),

  created() {},

  mounted() {},

  methods: {},

  computed: {
    spaceBetweenIconAndText() {
      if (this.fontsize === "h2") {
        return "mr-3";
      } else if (this.fontsize === "h3") {
        return "mr-2";
      } else {
        return "mr-1";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
